<main>
  <div>
    <img src="/M.png" alt=""/>
  </div>
</main>

<style>
  div {
    text-align: center;
  }
  img {
    width: 96px;
    height: 96px;
  }
</style>